import styles from './button.module.css';

type ButtonProps = {
  handleClick: any;
}

// TODO: PropsWithChildren etc
function Button({ children, ...props }: any) {
  return (
    <button className={styles.button} {...props}>
      {children}
    </button>
  )
}

export default Button;
